export { ActivitiesMessageComponent } from './activities-message.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/activities/activities-message/index.ts